var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "b-container",
    { staticClass: "px-0", attrs: { fluid: "" } },
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            [
              _c(
                "b-button",
                {
                  directives: [
                    {
                      name: "b-tooltip",
                      rawName: "v-b-tooltip.hover.left",
                      value: _vm.$t(
                        "apeironGwApp.claustroSnp.modalAsociar.titulo"
                      ),
                      expression:
                        "$t('apeironGwApp.claustroSnp.modalAsociar.titulo')",
                      modifiers: { hover: true, left: true },
                    },
                  ],
                  attrs: { size: "sm", variant: "outline" },
                  on: {
                    click: function ($event) {
                      return _vm.mostrarModal()
                    },
                  },
                },
                [_c("b-icon", { attrs: { icon: "link", variant: "primary" } })],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            [
              _c(
                "b-modal",
                {
                  attrs: {
                    name: "modal-instituciones-snp",
                    scrollable: "",
                    size: "xl",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "modal-title",
                      fn: function () {
                        return [
                          _c("span", {
                            domProps: {
                              textContent: _vm._s(
                                _vm.$t(
                                  "apeironGwApp.claustroSnp.modalAsociar.titulo"
                                )
                              ),
                            },
                          }),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "modal-footer",
                      fn: function () {
                        return [
                          _vm.esEscritura
                            ? _c(
                                "b-button",
                                {
                                  attrs: {
                                    variant: "primary",
                                    disabled: _vm.alumnos.length < 1,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.guardarAsociaciones()
                                    },
                                  },
                                },
                                [
                                  _c("span", {
                                    domProps: {
                                      textContent: _vm._s(
                                        _vm.$t(
                                          "apeironGwApp.claustroSnp.acciones.guardarSeccion"
                                        )
                                      ),
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("font-awesome-icon", {
                                    staticClass: "mr-2",
                                    attrs: { icon: "save" },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "b-button",
                            {
                              attrs: { variant: "secondary" },
                              on: {
                                click: function ($event) {
                                  _vm.mostrarModalAsociarAlumnos = false
                                },
                              },
                            },
                            [
                              _c("span", {
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.$t(
                                      "apeironGwApp.claustroSnp.acciones.cerrar"
                                    )
                                  ),
                                },
                              }),
                            ]
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                  model: {
                    value: _vm.mostrarModalAsociarAlumnos,
                    callback: function ($$v) {
                      _vm.mostrarModalAsociarAlumnos = $$v
                    },
                    expression: "mostrarModalAsociarAlumnos",
                  },
                },
                [
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c("b-col", { staticClass: "d-block text-center" }, [
                        _c("h4", {
                          domProps: {
                            textContent: _vm._s(
                              _vm.$t(
                                "apeironGwApp.claustroSnp.modal.detalleDetalle"
                              )
                            ),
                          },
                        }),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-form-group",
                            {
                              staticClass: "mb-2",
                              attrs: {
                                label: _vm.$t(
                                  "apeironGwApp.claustroSnp.form.cvuDocente"
                                ),
                                "label-for": "input-cvu",
                              },
                            },
                            [
                              _c("b-form-input", {
                                attrs: {
                                  name: "input-cvu",
                                  placeholder: _vm.$t(
                                    "apeironGwApp.claustroSnp.form.cvuDocente"
                                  ),
                                  disabled: "",
                                },
                                model: {
                                  value:
                                    _vm.participacionProfesor.participante.cvu,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.participacionProfesor.participante,
                                      "cvu",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "participacionProfesor.participante.cvu",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-form-group",
                            {
                              staticClass: "mb-2",
                              attrs: {
                                label: _vm.$t(
                                  "apeironGwApp.claustroSnp.form.nombreDocente"
                                ),
                                "label-for": "input-nombre-docente",
                              },
                            },
                            [
                              _c("b-form-input", {
                                attrs: {
                                  name: "input-nombre-docente",
                                  placeholder: _vm.$t(
                                    "apeironGwApp.claustroSnp.form.nombreDocente"
                                  ),
                                  disabled: "",
                                },
                                model: {
                                  value:
                                    _vm.participacionProfesor.participante
                                      .nombre,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.participacionProfesor.participante,
                                      "nombre",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "participacionProfesor.participante.nombre",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-form-group",
                            {
                              staticClass: "mb-2",
                              attrs: {
                                label: _vm.$t(
                                  "apeironGwApp.claustroSnp.form.apellidoPaterno"
                                ),
                                "label-for": "input-apellido-paterno",
                              },
                            },
                            [
                              _c("b-form-input", {
                                attrs: {
                                  name: "input-apellido-paterno",
                                  placeholder: _vm.$t(
                                    "apeironGwApp.claustroSnp.form.apellidoPaterno"
                                  ),
                                  disabled: "",
                                },
                                model: {
                                  value:
                                    _vm.participacionProfesor.participante
                                      .apellidoPaterno,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.participacionProfesor.participante,
                                      "apellidoPaterno",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "participacionProfesor.participante.apellidoPaterno",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-form-group",
                            {
                              staticClass: "mb-2",
                              attrs: {
                                label: _vm.$t(
                                  "apeironGwApp.claustroSnp.form.apellidoMaterno"
                                ),
                                "label-for": "input-apellido-materno",
                              },
                            },
                            [
                              _c("b-form-input", {
                                attrs: {
                                  name: "input-apellido-materno",
                                  placeholder: _vm.$t(
                                    "apeironGwApp.claustroSnp.form.apellidoMaterno"
                                  ),
                                  disabled: "",
                                },
                                model: {
                                  value:
                                    _vm.participacionProfesor.participante
                                      .apellidoMaterno,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.participacionProfesor.participante,
                                      "apellidoMaterno",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "participacionProfesor.participante.apellidoMaterno",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c("b-col", { staticClass: "d-block text-center mt-5" }, [
                        _c("h4", {
                          domProps: {
                            textContent: _vm._s(
                              _vm.$t(
                                "apeironGwApp.claustroSnp.modalAsociar.alumnos"
                              )
                            ),
                          },
                        }),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "my-2" },
                    [
                      _c("b-col", { attrs: { offset: "3" } }, [
                        _c("span", {
                          domProps: {
                            textContent: _vm._s(
                              _vm.$t(
                                "apeironGwApp.claustroSnp.modalAsociar.filtroCvu"
                              )
                            ),
                          },
                        }),
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        [
                          _c("b-form-input", {
                            attrs: {
                              name: "input-filtro-cvu",
                              placeholder: _vm.$t(
                                "apeironGwApp.claustroSnp.acciones.buscar"
                              ),
                            },
                            model: {
                              value: _vm.filtroAlumno,
                              callback: function ($$v) {
                                _vm.filtroAlumno = $$v
                              },
                              expression: "filtroAlumno",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-button",
                            {
                              attrs: { variant: "outline-primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.buscarDesdePrimerPagina()
                                },
                              },
                            },
                            [
                              _c("b-icon", {
                                attrs: { icon: "search", variant: "primary" },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("b-icon", {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip.hover.top",
                                value: _vm.$t(
                                  "apeironGwApp.alumnoSnp.ayudaBuscador"
                                ),
                                expression:
                                  "$t('apeironGwApp.alumnoSnp.ayudaBuscador')",
                                modifiers: { hover: true, top: true },
                              },
                            ],
                            staticClass: "float-right",
                            attrs: {
                              icon: "info-circle-fill",
                              variant: "success",
                              scale: "2",
                              animation: "fade",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        [
                          _c("b-table", {
                            attrs: {
                              "sticky-header": "500px",
                              fields: _vm.fieldsAlumnos,
                              items: _vm.alumnos,
                              busy: _vm.showLoading,
                              "thead-class": "custom-header",
                              "show-empty": "",
                              "empty-text": _vm.$t(
                                "apeironGwApp.claustroSnp.modalAsociar.sinRegistros"
                              ),
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "table-busy",
                                fn: function () {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "text-center my-2" },
                                      [
                                        _c("b-spinner", {
                                          staticClass: "align-middle",
                                        }),
                                        _vm._v(" "),
                                        _c("strong", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "global.process.load.loading"
                                              )
                                            )
                                          ),
                                        ]),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                              {
                                key: "cell(participante)",
                                fn: function (data) {
                                  return [
                                    _c("span", {
                                      domProps: {
                                        textContent: _vm._s(data.item?.nombre),
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("span"),
                                    _vm._v(" "),
                                    _c("span", {
                                      domProps: {
                                        textContent: _vm._s(
                                          data.item?.apellidoPaterno
                                        ),
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("span"),
                                    _vm._v(" "),
                                    _c("span", {
                                      domProps: {
                                        textContent: _vm._s(
                                          data.item?.apellidoMaterno
                                        ),
                                      },
                                    }),
                                  ]
                                },
                              },
                              {
                                key: "cell(asociado)",
                                fn: function (data) {
                                  return [
                                    _vm.esEscritura && data.item.activo
                                      ? _c("b-form-checkbox", {
                                          model: {
                                            value: data.item.asociado,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                data.item,
                                                "asociado",
                                                $$v
                                              )
                                            },
                                            expression: "data.item.asociado",
                                          },
                                        })
                                      : _vm._e(),
                                  ]
                                },
                              },
                              {
                                key: "cell(asociar)",
                                fn: function (data) {
                                  return [
                                    _c("b-form-select", {
                                      staticClass: "resaltar-opciones-disabled",
                                      attrs: {
                                        disabled:
                                          !_vm.esEscritura ||
                                          !data.item.asociado ||
                                          !data.item.activo,
                                        state: _vm.checarEstado(data.item),
                                        name: "input-funcion-relacion",
                                        options: _vm.opcionesFuncion,
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "first",
                                            fn: function () {
                                              return [
                                                _c(
                                                  "b-form-select-option",
                                                  {
                                                    attrs: {
                                                      value: undefined,
                                                      disabled: "",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm
                                                          .$t(
                                                            "apeironGwApp.claustroSnp.modalAsociar.seleccionarUno"
                                                          )
                                                          .toString()
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                      model: {
                                        value: data.item.relacion,
                                        callback: function ($$v) {
                                          _vm.$set(data.item, "relacion", $$v)
                                        },
                                        expression: "data.item.relacion",
                                      },
                                    }),
                                  ]
                                },
                              },
                              {
                                key: "cell(baja)",
                                fn: function (data) {
                                  return [
                                    _c("b-icon", {
                                      attrs: {
                                        icon: data.item.activo
                                          ? "toggle-on"
                                          : "toggle-off",
                                        variant: data.item.activo
                                          ? "success"
                                          : "secondary",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("span", {
                                      domProps: {
                                        textContent: _vm._s(
                                          _vm.$t(
                                            data.item.activo
                                              ? "apeironGwApp.claustroSnp.modalAsociar.si"
                                              : "apeironGwApp.claustroSnp.modalAsociar.no"
                                          )
                                        ),
                                      },
                                    }),
                                  ]
                                },
                              },
                              {
                                key: "cell(acciones)",
                                fn: function (data) {
                                  return [
                                    _vm.esEscritura &&
                                    data.item.activo &&
                                    !!data.item.relacion?.clave
                                      ? _c(
                                          "b-button",
                                          {
                                            directives: [
                                              {
                                                name: "b-tooltip",
                                                rawName: "v-b-tooltip.hover",
                                                value: _vm.$t(
                                                  "apeironGwApp.claustroSnp.modalAsociar.eliminarRelacion"
                                                ),
                                                expression:
                                                  "$t('apeironGwApp.claustroSnp.modalAsociar.eliminarRelacion')",
                                                modifiers: { hover: true },
                                              },
                                            ],
                                            attrs: {
                                              variant: "outline-primary",
                                              disabled:
                                                !_vm.esEscritura ||
                                                !data.item.relacion?.clave,
                                              size: "sm",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.eliminarRelacion(
                                                  data.item
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("b-icon", {
                                              attrs: { icon: "trash" },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.alumnos.length > 0
                    ? _c(
                        "b-row",
                        { staticClass: "mt-4" },
                        [
                          _c(
                            "b-col",
                            { attrs: { md: "4" } },
                            [
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    { attrs: { md: "4" } },
                                    [
                                      _c("b-form-select", {
                                        attrs: {
                                          size: "sm",
                                          id: "per-page-select",
                                          options: _vm.pageOptions,
                                        },
                                        on: {
                                          change: _vm.buscarDesdePrimerPagina,
                                        },
                                        model: {
                                          value: _vm.perPage,
                                          callback: function ($$v) {
                                            _vm.perPage = $$v
                                          },
                                          expression: "perPage",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "pie-tabla mt-1",
                                      attrs: { md: "8" },
                                    },
                                    [
                                      _c("span", {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "apeironGwApp.claustroSnp.modalAsociar.registrosPorPagina"
                                            )
                                          ),
                                        },
                                      }),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { attrs: { md: "4" } },
                            [
                              _c("b-pagination", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.totalRows / _vm.perPage > 1,
                                    expression: "totalRows / perPage > 1",
                                  },
                                ],
                                attrs: {
                                  size: "sm",
                                  "total-rows": _vm.totalRows,
                                  "per-page": _vm.perPage,
                                  align: "fill",
                                  pills: "",
                                },
                                on: { change: _vm.cambiarPagina },
                                model: {
                                  value: _vm.currentPage,
                                  callback: function ($$v) {
                                    _vm.currentPage = $$v
                                  },
                                  expression: "currentPage",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            {
                              staticClass: "text-right pie-tabla mt-1",
                              attrs: { md: "4" },
                            },
                            [
                              _c("span", {
                                domProps: {
                                  textContent: _vm._s(_vm.totalRows),
                                },
                              }),
                              _c("span", {
                                staticClass: "ml-1",
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.$t(
                                      "apeironGwApp.claustroSnp.modalAsociar.totalDeRegistros"
                                    )
                                  ),
                                },
                              }),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.esEscritura
                    ? _c(
                        "b-row",
                        { staticClass: "mt-3" },
                        [
                          _c(
                            "b-col",
                            [
                              _c(
                                "b-alert",
                                { attrs: { show: "", variant: "info" } },
                                [
                                  _c("span", {
                                    domProps: {
                                      textContent: _vm._s(
                                        _vm.$t(
                                          "apeironGwApp.claustroSnp.modalAsociar.guardarSeccion",
                                          {
                                            guardarSeccion: _vm
                                              .$t(
                                                "apeironGwApp.claustroSnp.acciones.guardarSeccion"
                                              )
                                              .toString(),
                                          }
                                        )
                                      ),
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("hr"),
                                  _vm._v(" "),
                                  _c("span", {
                                    domProps: {
                                      textContent: _vm._s(
                                        _vm.$t(
                                          "apeironGwApp.claustroSnp.modalAsociar.activarRelacion"
                                        )
                                      ),
                                    },
                                  }),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }